import { render, staticRenderFns } from "./QuizTop.vue?vue&type=template&id=77ab00f4&scoped=true&"
import script from "./QuizTop.vue?vue&type=script&lang=ts&"
export * from "./QuizTop.vue?vue&type=script&lang=ts&"
import style0 from "./QuizTop.vue?vue&type=style&index=0&id=77ab00f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ab00f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VBtn,VContainer,VIcon,VRadio,VRadioGroup})
